import ReFetch from './refetch'
import { successful as recordToken, failed as authFailed } from '../actions'
import { refreshToken } from './retry'

const callAPI = (url, { token, body, method, jsonAPI, accept, mimeType = null }, dispatch) => {
  const retry = (originalRequest) =>
    // we need to request a new token
    // (then replay the request with our new token)
    refreshToken()
      .then(({ token }) => {
        // Issue:
        // When a user submits a form (e.g. creating a new enrolment), if the dispatch(recordToken) goes off it does
        // a re-render which causes the page to lose its state. If a request fails (e.g. because of bad data)
        // end-users never see the error message so they don't know what's going on
        //
        // Workaround: for POST requests only, replay the request but don't update the token
        // Pros:
        //  - State does not get lost, users can still see the result of what they've done
        //  - The next GET request will refresh the token and save/dispatch(recordToken) it
        // Cons:
        // - We make extra, unnecessary, `refreshToken` API requests
        // - If multiple POSTs go off in a row, then multiple refreshes will be made
        // - Some requests are POSTs - even if its not specifically to submit a form
        if (originalRequest.method !== "POST") {
          dispatch(
            recordToken({
              data: {
                token,
              },
            })
          );
        }

        return originalRequest.callWithToken(token)
      })
      .catch(({ message }) => failed(message))

  const failed = (message = 'Authentication expired') => {
    dispatch(authFailed({ errors: message }))

    return Promise.resolve(
      new Response(JSON.stringify({ message }), {
        status: 400,
      })
    )
  }

  const processResponse = response => (response.status === 401 ? retry(request) : response)

  // Record the params for the request
  // (incase we need to replay again with a new token)
  const request = new ReFetch(url, {
    body,
    method,
    jsonAPI,
    accept,
    mimeType,
  })

  return request
    .callWithToken(token)
    .then(response => processResponse(response))
    .catch(error => Promise.reject(error))
}

export { refreshToken }

export default callAPI



// WEBPACK FOOTER //
// ./src/authorisation/fetch-with-retry/index.js